import DownloadAppButton from './DownloadAppButton';

export { PlatformType } from './DownloadAppButton.types';
export default DownloadAppButton;
